import { render, staticRenderFns } from "./WYSIWYGBlok.vue?vue&type=template&id=21e2a7a6&"
import script from "./WYSIWYGBlok.vue?vue&type=script&lang=js&"
export * from "./WYSIWYGBlok.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports